module.exports = __webpack_public_path__ + "img/Web Menu Icon - charcoal.d7b113ea.svg";